import { SxProps } from '@mui/material';
import ContextMenu from './ContextMenu';

import useContextMenuOptions from './useContextMenuOptions';

interface ContextMenuContainerProps {
  onOpen?: (open: boolean) => void;
  eventId: string;
  clientId: string;
  schedulingLabel: string;
  scheduleStart?: string;
  hasAppointmentGrouping: boolean;
  hasEmployee: boolean;
  isEditable: boolean;
  isCreditable: boolean;
  isCredit: boolean;
  isAbsent: boolean;
  eventIsOpen: boolean;
  isAssigned: boolean;
  isProject: boolean;
  isWorkPlace: boolean;
  sx?: SxProps;
}

export default function ContextMenuContainer({
  clientId,
  eventId,
  schedulingLabel,
  scheduleStart,
  hasAppointmentGrouping,
  hasEmployee,
  isEditable,
  isCreditable,
  isCredit,
  isAbsent,
  eventIsOpen,
  isAssigned,
  isProject,
  isWorkPlace,
  onOpen,
  sx
}: ContextMenuContainerProps) {
  const { options, handleOptionClick } = useContextMenuOptions({
    eventId,
    clientId,
    schedulingLabel,
    scheduleStart,
    isEditable,
    isAbsent,
    eventIsOpen,
    isAssigned,
    isProject,
    isWorkPlace,
    hasAppointmentGrouping,
    hasEmployee,
    isCreditable,
    isCredit
  });

  return (
    <ContextMenu
      sx={sx}
      options={options}
      onOptionClick={handleOptionClick}
      onOpen={onOpen}
    />
  );
}
